<template lang='pug'>
  div.p-absolute
    div.backgroundFull.show(
      @click='closeCalendar'
      )
    transition(name='fadeSlide')
      div.maxSizeHeight.show(v-show='showView')
        div.content
          ods-row.sc-dashboard__row(type='flex' :gutter='16')
            //- Calendar
            ods-col.sc-dashboard__col(:span='24')
              Card.calendar(size='small' :loading='!!!getCalendarData' :scrollbar='false')
                template(slot='header')
                  button.ods-dialog__headerbtn(@click='closeCalendar' type="button" aria-label="Close")
                    i.ods-dialog__close.ods-icon.ods-icon-close
                  div.card-title {{ $t('Calendar') }}
                  div
                    ods-date-picker(v-model='datePicker' type='date' :placeholder='$t("pickaday")' @change='dateChanged')
                    ods-button.today-button(type='secondary' size='small' round v-if='!isToday' @click.native='goToday') Hoy
                div(v-if='getCalendarData && getCalendarData.length')
                  Timeline(
                    :data='item'
                    v-for='(item, index) in getCalendarData'
                    :key='index'
                  )
                div(v-else-if='getCalendarData && !getCalendarData.length')
                  StatusCero(
                    title='SIN DATOS'
                    description='No existen eventos para el día seleccionado. Por favor seleccione otra fecha.'
                  )
  //- End Calendar
</template>

<script>

import moment from 'moment'
import Card from '@/components/Card'
import Timeline from '@/components/Timeline'
import StatusCero from '@/components/StatusCero'

import jsonCalendar from '@/moks/json/calendar'

export default {
  name: 'Calendar',
  data () {
    return {
      datePicker: '',
      showView: false,
      getCalendarData: []
    }
  },
  props: {
    actived: {
      type: Boolean
    }
  },
  computed: {
    isToday () {
      if (this.datePicker) {
        let today = new Date()
        let isToday = (today.toDateString() === this.datePicker.toDateString())
        return isToday
      } else {
        return true
      }
    }
  },
  methods: {
    init () {
      // this.initDate()
      this.getCalendarData = jsonCalendar
    },
    initDate () {
      const today = new Date()
      this.$store.dispatch('updateCalendar', today.toISOString())
    },
    dateChanged (value) {
      if (value) {
        let date = moment(value).format('YYYY-MM-DD[T]HH:mm:ss.SSSZZ')
        this.$store.dispatch('updateCalendar', date)
      } else {
        this.initDate()
      }
    },
    closeCalendar () {
      this.showView = false
      this.$emit('closeCalendar')
    },
    goToday () {
      this.datePicker = new Date()
      this.initDate()
    }
  },
  components: {
    StatusCero,
    Timeline,
    Card
  },
  created () {
    this.init()
  },
  mounted () {
    this.showView = true
    document.body.appendChild(this.$el)
  }
}
</script>

<style scoped lang="scss">

.p-absolute{
  .maxSizeHeight {
    background: $--color-white;
    position: fixed;
    right: 0;
    top: 0;
    width: 30%;
    z-index: 2001;
    .content {
      width: 100%;
      height: calc(100vh);
    }
    .sc-card{
      box-shadow: none !important;
    }
  }
  /deep/ .sc-card__header{
    padding: rem(60) rem(32) 0 rem(32);
  }
  .ods-dialog__close{
    font-size: rem(22);
  }
  .ods-date-editor.ods-input {
    width: auto;
    // width: rem(120);
  }
  .today-button {
    margin-left: rem(16);
  }
  /deep/ .calendar .sc-card__body{
    padding: rem(24);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Calendar.vue